module.exports = __webpack_public_path__ + "media/cookies/cookie-success-208f506c.svg";